import { createStore } from 'redux';

// Example reducer (replace with your own)
const rootReducer = (state = {}, action) => {
  switch(action.type) {
    // your reducer logic here
    default:
      return state;
  }
};

const store = createStore(rootReducer);

export default store;
